import { call, put, takeLatest, select } from 'redux-saga/effects';
import violationReportService from '../../../services/violationReportService';
import {
  fetchInit,
  fetchInitSuccess,
  fetchInitFailure,
  fetchViolationReport,
  fetchViolationReportSuccess,
  fetchViolationReportFailure,
  exportViolationReportToExcel,
  exportViolationReportToExcelSuccess,
  exportViolationReportToExcelFailure,
  exportViolationReportToPdf,
  exportViolationReportToPdfSuccess,
  exportViolationReportToPdfFailure,
  selectViolationReportFilterUnitId,
  selectViolationReportFilterFromDate,
  selectViolationReportFilterToDate,
} from './slice';

function* handleFetchInit() {
  try {
    const response = yield call(violationReportService.getInit);
    yield put(fetchInitSuccess(response));
  } catch (error) {
    yield put(fetchInitFailure(error.message || 'reports.violation.errors.fetchInitFailed'));
  }
}

// Helper to check if value is empty (null, undefined, or empty string - NOT 0)
const isEmpty = (value) => value === '' || value === null || value === undefined;

function* handleFetchViolationReport() {
  try {
    // Get current filter values
    const unitId = yield select(selectViolationReportFilterUnitId);
    const fromDate = yield select(selectViolationReportFilterFromDate);
    const toDate = yield select(selectViolationReportFilterToDate);

    // Validate filters
    if (isEmpty(unitId) || isEmpty(fromDate) || isEmpty(toDate)) {
      yield put(fetchViolationReportFailure('reports.violation.errors.selectFilters'));
      return;
    }

    const params = {
      unitId,
      fromDate,
      toDate,
    };

    const response = yield call(violationReportService.getViolationReport, params);
    yield put(fetchViolationReportSuccess(response));
  } catch (error) {
    yield put(fetchViolationReportFailure(error.message || 'reports.violation.errors.fetchFailed'));
  }
}

function* handleExportViolationReportToExcel() {
  try {
    // Get current filter values
    const unitId = yield select(selectViolationReportFilterUnitId);
    const fromDate = yield select(selectViolationReportFilterFromDate);
    const toDate = yield select(selectViolationReportFilterToDate);

    // Validate filters (same as fetch report)
    if (isEmpty(unitId) || isEmpty(fromDate) || isEmpty(toDate)) {
      yield put(exportViolationReportToExcelFailure('reports.violation.errors.selectFilters'));
      return;
    }

    const params = {
      unitId,
      fromDate,
      toDate,
    };

    yield call(violationReportService.exportViolationReportToExcel, params);
    yield put(exportViolationReportToExcelSuccess('reports.violation.exportSuccess'));
  } catch (error) {
    yield put(exportViolationReportToExcelFailure(error.message || 'reports.violation.errors.exportFailed'));
  }
}

function* handleExportViolationReportToPdf() {
  try {
    // Get current filter values
    const unitId = yield select(selectViolationReportFilterUnitId);
    const fromDate = yield select(selectViolationReportFilterFromDate);
    const toDate = yield select(selectViolationReportFilterToDate);

    // Validate filters (same as fetch report)
    if (isEmpty(unitId) || isEmpty(fromDate) || isEmpty(toDate)) {
      yield put(exportViolationReportToPdfFailure('reports.violation.errors.selectFilters'));
      return;
    }

    const params = {
      unitId,
      fromDate,
      toDate,
      type: 'pdf',
    };

    yield call(violationReportService.exportViolationReportToExcel, params);
    yield put(exportViolationReportToPdfSuccess('reports.violation.exportPdfSuccess'));
  } catch (error) {
    yield put(exportViolationReportToPdfFailure(error.message || 'reports.violation.errors.exportPdfFailed'));
  }
}

export function* watchViolationReportActions() {
  yield takeLatest(fetchInit.type, handleFetchInit);
  yield takeLatest(fetchViolationReport.type, handleFetchViolationReport);
  yield takeLatest(exportViolationReportToExcel.type, handleExportViolationReportToExcel);
  yield takeLatest(exportViolationReportToPdf.type, handleExportViolationReportToPdf);
}
